export default {
    templates: {
        preview: 'Preview', use: 'Use template', by: 'By {name}', questions: '{count} question | {count} questions',
        delete: 'Delete template: {title}', media: 'Media response', text: 'Text response', choice: 'Choice', rating: 'Rating', date: 'Date', number: 'Number',
    },
    card: {
        by: 'By {name} · {date}', me: 'me', public: 'Public request', private: 'Private request',
        invited: '{count} invited', closed: 'Link closed', responses: '{count} response | {count} responses',
        copy: 'Copy link', view: 'View responses',
    },
    workspace: {
        title: 'Requests', subtitle: 'Create requests, track responses, and contribute to your channel.',
        scope: 'Manage requests', status: 'Request status', mine: 'My requests', channel: 'Channel requests', shared: 'Shared access', sharedHint: 'Requests shared with you to review or manage',
        forYou: 'Requests to answer', forYouSubtitle: 'Invitations and open requests in your channel.',
        sharedEmpty: 'No requests shared with you', sharedEmptyDescription: 'Requests shared with you for review or management will appear here.',
        invited: 'Sent to me', open: 'Open requests',
        invitedEmpty: 'No requests waiting for you', invitedEmptyDescription: 'New invitations will appear here.',
        openEmpty: 'No open requests right now', openEmptyDescription: 'Check back for requests you can contribute to.',
        loading: 'Loading requests', error: 'Could not load your requests.', retry: 'Try again',
        respond: 'Respond', respondTo: 'Respond to {title}', samples: 'Sample requests', from: 'From {name}', due: 'Due {date}', video: 'Video request', survey: 'Request',
        previous: 'Previous requests', next: 'Next requests', page: '{page} of {total}',
    },
    // A
    addDirection: 'Add direction',
    analyzeYourVideo: 'Analyze your video transcripts and proofing comments to complete your edit request with precise AI assistance.',

    // C
    chooseColleague: 'Choose a colleague',
    chooseDirection: 'Choose direction',
    chooseExpert: 'Choose expert',
    colleaguesAndGuests: 'Colleagues and Guests',
    colleaguesAndGuestsSubtitle: 'Request videos from within your community and guest users',

    // E
    editsInProgressAlertTextPrefix: 'At least 5 edits are in progress for',
    editsInProgressAlertTextSuffix: 'this channel',
    editsInProgressAlertTitle: 'You have maxed your edit request for this channel',
    externalOpenLink: 'External Open Link',
    externalOpenLinkSubtitle: 'A convenient link to request videos from your network',

    // I
    industryExperts: 'Industry Experts',
    industryExpertsSubtitle: 'Pitch your soundbite idea to an industry expert thought leader',

    // K
    keepThisPageOpen: `Keep this page open, and you'll have a response in no time.`,

    // M
    modifyImproveAdditionalNotes: `Modify, improve, and add additional notes, or try again.`,

    // R
    request: 'Request',

    // S
    saveEdits: 'Save Edits',
    selectApprover: 'Select approver',

    // W
    whoWouldLikeApprove: 'Who would you like to help approve this content?',
}
